/* file description */

import type { UseFetchData } from './type';
import { debounce } from 'lodash';
import { getModuleRecordList } from '@/common/asset-apis/assetModel';
import { getRecordListByParams } from '@/common';

export const useFetchData: UseFetchData = ({ setOptionList, API, field, filter, setSearchValue }) => {
  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  const handleSearch = debounce((value) => {
    const { dataKey, treeId, label, fetchColumn } = field.options || {};
    setSearchValue(value);
    if (!(value?.length > 0)) {
      return;
    }
    let filterParams = `(${label} ILIKE '%${value}%')`;
    if (fetchColumn && fetchColumn?.length > 0) {
      let fetchParams = '';
      fetchColumn.forEach((item: string) => {
        fetchParams = fetchParams ? `${fetchParams} OR ${item} ILIKE '%${value}%'` : `${item} ILIKE '%${value}%'`;
      });
      filterParams = `(${fetchParams})`;
    }
    if (filter) {
      filterParams = `${filterParams} AND ${filter}`;
    }
    if (API?.ComposeAPI) {
      getRecordListByParams({
        ComposeAPI: API.ComposeAPI,
        params: {
          moduleID: dataKey,
          namespaceID: treeId,
          filter: filterParams,
        },
      }).then(({ set }) => {
        setOptionList(set.map((r: any) => convert(r)));
      });
    } else {
      getModuleRecordList(
        API.FetchAPI,
        treeId,
        dataKey,
        {
          moduleID: dataKey,
          namespaceID: treeId,
          filter: filterParams,
        },
      ).then(({ set }) => {
        setOptionList(set.map((r: any) => convert(r)));
      });
    }
  }, 300);

  return {
    handleSearch,
  };
};
